module.exports = __webpack_public_path__ + "static/media/About_Illustration.4e68a6a9.png";